import { useEffect, useState } from 'react';
import styles from './TenantType.module.css';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { tenantDetails } from '../../helpers/utils/types';
import { updateTenantDetails } from '../../auth/_requests';
import { useAuth } from '../../auth/Auth';
import { postLoginTask } from '../../helpers/utils/login';
import { AuthBrandedLoader } from '../Login/AuthBrandedLoader';
import SVGChecked from '../../helpers/SVG/SVGRadio/SVGChecked';
import SVGUnchecked from '../../helpers/SVG/SVGRadio/SVGUnchecked';
import loginStyles from '../Login/Login.module.css';
import { AuthPageShell } from '../Login/AuthPageShell';
import { trackOnboardingStepCompleted } from '../../helpers/utils/analytics';

const TenantType: React.FC<{ tenant?: tenantDetails }> = ({ tenant }) => {
  const { auth, saveAuth } = useAuth();

  const [formData, setFormData] = useState({
    accountType: '', // 'individual' or 'business'
    propertyType: '', // 'newProperty' or 'oldProperty'
  });
  const [error1, setError1] = useState(false);
  // const [error2, setError2] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const updateData = {
    tenantDetails: {
      accountType: formData.accountType,
      isNewProperty: formData.propertyType === 'newProperty',
    },
  };
  const handleAccountTypeClick = (inputValue: string) => {
    setFormData((prevData) => ({
      ...prevData,
      accountType: prevData.accountType === inputValue ? '' : inputValue,
    }));
  };

  // const handlePropertyTypeClick = (inputValue: string) => {
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     propertyType: prevData.propertyType === inputValue ? '' : inputValue,
  //   }));
  // };
  const handleSubmitBtn = async (e: React.FormEvent) => {
    e.preventDefault();
    let valid = true;
    if (formData.accountType === '') {
      setError1(true);
      valid = false;
    }
    // if (formData.propertyType === '') {
    //   setError2(true);
    //   valid = false;
    // }
    if (valid) {
      await updateTenantDetails(auth?.data.token, updateData);
      if (auth) {
        trackOnboardingStepCompleted('account_type');
        await postLoginTask(auth, navigate, saveAuth);
      }
    }
  };
  useEffect(() => {
    if (tenant) {
      setFormData({
        accountType: tenant?.tenant.accountType,
        propertyType: tenant?.tenant.isNewProperty ? 'newProperty' : 'oldProperty',
      });
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [tenant]);
  if (loading) {
    return <AuthBrandedLoader message='Loading…' />;
  }
  return (
    <AuthPageShell variant='center'>
      <div className={loginStyles.authFlowMax}>
        <motion.main className={`${loginStyles.main} ${loginStyles.mainWide}`} initial={false}>
          <div className={loginStyles.formEyebrow}>Onboarding</div>
          <div className={loginStyles.formTitle}>Success!</div>
          <p className={loginStyles.forgotText}>
            Your email has been verified. Let&apos;s get started!
          </p>
          <form className={styles.form}>
            <div className={styles.formHead}>How would you like to create your account?</div>
            <div className={loginStyles.authOptionsStack}>
              <button
                type='button'
                className={loginStyles.authSelectRow}
                onClick={() => {
                  handleAccountTypeClick('personal');
                  setError1(false);
                }}
              >
                {formData.accountType === 'personal' ? <SVGChecked /> : <SVGUnchecked />}
                <div className={loginStyles.authSelectLabel}>Individual</div>
              </button>
              <button
                type='button'
                className={loginStyles.authSelectRow}
                onClick={() => {
                  handleAccountTypeClick('business');
                  setError1(false);
                }}
              >
                {formData.accountType === 'business' ? <SVGChecked /> : <SVGUnchecked />}
                <div className={loginStyles.authSelectLabel}>Business or organization</div>
              </button>
              {error1 && <div className={styles.error}>Please select an account type</div>}
            </div>
            {/* To be later replaced for existing properties */}

            {/* <div className={styles.formHead}>Select the type of property.</div> */}
            {/* <div className={styles.inputBoxOuter}>
            <div
              className={styles.inputBox}
              onClick={() => {
                handlePropertyTypeClick('newProperty');
                setError2(false);
              }}
            >
              <img
                src={formData.propertyType === 'newProperty' ? checked : unchecked}
                alt='radio'
                className={styles.radioBtn}
              />
              <div className={styles.label}>New Property</div>
            </div>
            <div
              className={styles.inputBox}
              onClick={() => {
                handlePropertyTypeClick('oldProperty');
                setError2(false);
              }}
            >
              <img
                src={formData.propertyType === 'oldProperty' ? checked : unchecked}
                alt='radio'
                className={styles.radioBtn}
              />
              <div className={styles.label}>Existing Property</div>
            </div>
            {error2 && <div className={styles.error}>Please select a property type</div>}
          </div> */}
            <button
              type='submit'
              className={`${loginStyles.submitBtn} ${
                (formData.accountType === '' || formData.propertyType === '') &&
                loginStyles.disableBtn
              }`}
              onClick={(e) => handleSubmitBtn(e)}
            >
              Next
            </button>
          </form>
        </motion.main>
      </div>
    </AuthPageShell>
  );
};

export default TenantType;
